import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import { MdOutlineBlock } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import "./BlockConfirmationModal.css";
// Shared modal styles (adjust the path to wherever you saved this file)
// import "./Devicesessionmodals.css";

export interface BlockConfirmationModalProps {
  show: boolean;
  onHide?: () => void;
  onClose?: () => void;
  onConfirm?: () => void | Promise<void>;
  submit?: () => void | Promise<void>;
  userName?: string;
  title?: string;
  message?: React.ReactNode;
  confirmText?: string;
  buttonText?: string;
  cancelText?: string;
  isBlocking?: boolean;
  loading?: boolean;
  disabled?: boolean;
}

const BlockConfirmationModal: React.FC<BlockConfirmationModalProps> = ({
  show,
  onHide,
  onClose,
  onConfirm,
  submit,
  userName,
  title,
  message,
  confirmText,
  buttonText,
  cancelText = "Cancel",
  isBlocking = false,
  loading = false,
  disabled = false,
}) => {
  const isLoading = isBlocking || loading;

  const handleClose = () => {
    if (onHide) onHide();
    else if (onClose) onClose();
  };

  const candidateName = userName || "this user";
  const displayTitle = title || `Block ${candidateName}`;
  const displayMessage =
    message !== undefined
      ? message
      : `Are you sure you want to block ${candidateName}? Blocking this user will prevent them from sending messages or viewing profile.`;

  const primaryBtnText = confirmText || buttonText || "Block User";

  const handleAction = async () => {
    const fn = onConfirm || submit;
    if (fn) await fn();
  };

  return (
    <Modal
      className="ChatConfirmModal BlockConfirmModal"
      show={show}
      onHide={isLoading ? undefined : handleClose}
      centered
      backdrop="static"
      contentClassName="dm-content"
      backdropClassName="dm-backdrop"
    >
      {/* Close Button */}
      <button
        type="button"
        className="dm-close"
        onClick={handleClose}
        disabled={isLoading}
        aria-label="Close"
        title="Close modal"
      >
        <IoClose size={18} />
      </button>

      <Modal.Body className="dm-body">
        <div className="dm-icon">
          <MdOutlineBlock size={28} />
        </div>
        <h2 className="dm-title">{displayTitle}</h2>
        {displayMessage && <div className="dm-text">{displayMessage}</div>}
      </Modal.Body>

      <Modal.Footer className="dm-footer">
        <button
          type="button"
          className="dm-btn dm-btn-cancel"
          onClick={handleClose}
          disabled={isLoading}
        >
          {cancelText}
        </button>
        <button
          type="button"
          className="dm-btn dm-btn-danger"
          onClick={handleAction}
          disabled={isLoading || disabled}
        >
          {isLoading ? (
            <>
              <Spinner animation="border" size="sm" variant="light" />
              <span>Blocking...</span>
            </>
          ) : (
            primaryBtnText
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default BlockConfirmationModal;